import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Currency/Combo', method: 'GET', token: token })
}
